module.exports = __webpack_public_path__ + "static/media/the-input-2020.1b2756a0.png";